import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum MessageDirection {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum MarketingMessageType {
  INITIAL = "INITIAL",
  REPLY = "REPLY",
}

const marketingMessageSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  conversationId: zExt.objectId(),
  content: z.string(),
  direction: createEnum(MessageDirection),
  type: createEnum(MarketingMessageType),
  to: z.string(),
  from: z.string(),
  llmThreadId: zExt.objectId().nullish(),
  draftedAt: z.date().nullish(),
  scheduledAt: z.date().nullish(),
  sentAt: z.date().nullish(),
  idempotencyKey: z.string().optional(), // Webhook unique ID for inbound messages only
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const marketingMessageSchema: z.ZodType<MarketingMessage> =
  marketingMessageSchema_;

export interface MarketingMessage
  extends z.infer<typeof marketingMessageSchema_> {}
